import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetLocation  {
    _originalTypeClassName = "zERP.BO.AssetLocation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetLocation.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Code = null;
this.Description = null;
this.FullName = null;
this.FullDescription = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
FullName:any;
FullDescription:any;
Entity:any;
ParentLocation:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setParentLocation = ($this, value) => {
var oldValue = $this.ParentLocation;
$this.ParentLocation = value;
if (value != null) {
}
}

static GetFullName($this: any): any{return CLMS.Framework.String.Format("{0} - {1}", $this?.Code, $this?.Description);
}
static UpdateFullDescription($this: any): any{let fullDescription = $this?.FullName;
let parentLocation = $this?.ParentLocation;
let safetyCounter = 20;
while (CLMS.Framework.Number.GreaterThan(() => safetyCounter, () => 0) && parentLocation != null && !(Domain.AssetLocation.IsNew(parentLocation))) {fullDescription = parentLocation?.Description + " >>> " + fullDescription;parentLocation = parentLocation?.ParentLocation;safetyCounter = Joove.Common.safeNumber(safetyCounter) - Joove.Common.safeNumber(1);}
$this.FullDescription = fullDescription;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}